export const RENOVATIONS_RECIEVED = "RENOVATIONS_RECIEVED"
export const RENOVATION_SAVED = "RENOVATION_SAVED"
export const RENOVATION_DELETED = "RENOVATION_DELETED"
export const RENOVATION_UNLOADED = "RENOVATION_UNLOADED"
